module.exports = __webpack_public_path__ + "rapid-prototyping-design.1LaSyX7l.svg";